import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Boxes, Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const CATS = ["All", "Platform", "Studio", "Enterprise"];

export default function Products() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data)).catch(() => {});
  }, []);

  const filtered = cat === "All" ? products : products.filter((p) => p.category === cat);

  return (
    <section id="products" className="py-20 lg:py-28 surface-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-semibold mb-3">Products</p>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-emerald-50 uppercase tracking-tight">
              Built on <span className="gold-gradient-text">Luchii & Frasberg</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                data-testid={`product-filter-${c.toLowerCase()}`}
                className={`px-4 py-2 rounded-full text-sm tracking-wide transition-all border ${
                  cat === c
                    ? "bg-gold text-emerald-950 border-gold"
                    : "border-emerald-900/60 text-slate-300 hover:border-emerald-500/50"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((p) => (
            <div
              key={p.id}
              data-testid={`product-card-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              className="rounded-2xl border border-emerald-900/60 surface-panel p-7 hover-emerald-glow flex flex-col"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-11 h-11 rounded-xl border border-emerald-400/30 bg-emerald-500/10 flex items-center justify-center">
                  <Boxes className="w-5 h-5 text-emerald-300" />
                </div>
                <Badge className="bg-transparent border border-emerald-800 text-slate-400 rounded-full text-[10px] tracking-wider">
                  {p.model_family}
                </Badge>
              </div>
              <h3 className="text-lg text-emerald-50 font-semibold font-garamond tracking-wide">{p.name}</h3>
              <p className="text-sm text-slate-400 leading-relaxed mt-2 flex-1">{p.description}</p>
              <div className="flex items-center justify-between mt-6 pt-4 border-t border-emerald-900/60">
                <span className="text-gold text-sm font-mono">{p.price}</span>
                <span className="flex items-center gap-1.5 text-[11px] text-emerald-300">
                  <Check className="w-3.5 h-3.5" /> {p.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
